export const selectedGrid = ({ listing }) => listing.gridViewFromConfig ?? listing.gridView;

export const selectListingProductsInfo = ({ listing }) => {
    const { productsCount, query } = listing;
    return {
        productsCount,
        productsPerPage: query.limit
    };
};

export const listingGridSelector = ({ listing }) => {
    const {
        gridViewFromConfig, gridOptions, gridView
    } = listing;
    return {
        gridViewFromConfig, gridOptions, gridView
    };
};

export const selectListingPageInfo = ({ listing }) => {
    const { pageInfo, productsGroup } = listing;
    const { brand, pageTitle } = pageInfo ?? {};

    return { brand, pageTitle, productsGroup };
};
